export const OPTION_HEADER_AND_FOOTER = 'header_as_footer';
export const OPTION_HEADER_ONLY = 'header_only';
export const OPTION_WITH_UNIQUE_FOOTER = 'unique_footer';
export const OPTION_FOOTER_ONLY = 'footer_only';

export const BRANDING = 'branding';
export const ADVANCED = 'advanced';

export const FONT_BENTON = 'benton';
export const FONT_PROXIMA_NOVA = 'proxima-nova';
export const FONT_LATO = 'lato';
export const FONT_MERRIWEATHER = 'merriweather';
export const FONT_MONTSERRAT = 'montserrat';
export const FONT_OPEN_SANS = 'open-sans';
export const FONT_ROBOTO = 'roboto';
export const FONT_SLABO_27PX = 'slabo-27px';
export const FONT_ARIAL = 'arial';
export const FONT_ARIAL_BLACK = 'arial-black';
export const FONT_BOOK_ANTIQUA = 'book-antiqua';
export const FONT_COURIER_NEW = 'courier-new';
export const FONT_GEORGIA = 'georgia';
export const FONT_HELVETICA = 'helvetica';
export const FONT_IMPACT = 'impact';
export const FONT_TAHOMA = 'tahoma';
export const FONT_TIMES_NEW_ROMAN = 'times-new-roman';
export const FONT_TREBUCHET_MS = 'trebuchet-ms';
export const FONT_VERDANA = 'verdana';

export const TINYMCE_GOOGLE_FONTS = [
  { id: FONT_ARIAL_BLACK, name: 'Arial Black', fallback: 'avant garde' },
  { id: FONT_BOOK_ANTIQUA, name: 'Book Antiqua', fallback: 'palatino' },
  { id: FONT_COURIER_NEW, name: 'Courier New', fallback: 'courier' },
  { id: FONT_GEORGIA, name: 'Georgia', fallback: 'palatino' },
  { id: FONT_HELVETICA, name: 'Helvetica', fallback: 'sans-serif' },
  { id: FONT_IMPACT, name: 'Impact', fallback: 'chicago' },
  { id: FONT_TAHOMA, name: 'Tahoma', fallback: 'sans-serif' },
  { id: FONT_TIMES_NEW_ROMAN, name: 'Times New Roman', fallback: 'times' },
  { id: FONT_TREBUCHET_MS, name: 'Trebuchet MS', fallback: 'geneva' },
  { id: FONT_VERDANA, name: 'Verdana', fallback: 'geneva' }
];

export const FONTS = [
  { id: FONT_PROXIMA_NOVA, name: 'ProximaNova', fallback: 'Arial, sans-serif' },
  { id: FONT_LATO, name: 'Lato', fallback: 'sans-serif' },
  { id: FONT_MERRIWEATHER, name: 'Merriweather', fallback: 'Georgia, serif' },
  { id: FONT_MONTSERRAT, name: 'Montserrat', fallback: 'Verdana, sans‑serif' },
  { id: FONT_OPEN_SANS, name: 'Open Sans', fallback: 'Tahoma, sans-serif' },
  { id: FONT_ROBOTO, name: 'Roboto', fallback: 'Tahoma, sans-serif' },
  { id: FONT_SLABO_27PX, name: 'Slabo 27px', fallback: 'Georgia, serif' },
  { id: FONT_BENTON, name: 'Benton', fallback: 'Tahoma, serif' },
  { id: FONT_ARIAL, name: 'Arial', fallback: 'sans-serif' }
];

export const FONTS_WITH_TINYMCE_GOOGLE_FONTS = [...FONTS, ...TINYMCE_GOOGLE_FONTS];

export const GOOGLE_FONTS = [
  FONT_LATO,
  FONT_MERRIWEATHER,
  FONT_MONTSERRAT,
  FONT_OPEN_SANS,
  FONT_ROBOTO,
  FONT_SLABO_27PX,
  FONT_ARIAL_BLACK,
  FONT_BOOK_ANTIQUA,
  FONT_COURIER_NEW,
  FONT_GEORGIA,
  FONT_HELVETICA,
  FONT_IMPACT,
  FONT_TAHOMA,
  FONT_TIMES_NEW_ROMAN,
  FONT_TREBUCHET_MS,
  FONT_VERDANA
];

export const DEFAULT_FONT = {
  id: FONT_PROXIMA_NOVA,
  name: 'ProximaNova'
};

export const DEFAULT_COLORS_BG = ['#6a95c0', '#5f9996', '#80cfb7', '#efd383', '#ffffff', '#143a50', '#737373'];
export const DEFAULT_COLORS_FONT = ['#eaeaea', '#5f9996', '#444444', '#efd383', '#ce7b79', '#826fa3', '#ffffff'];
export const DEFAULT_ACTIVE_COLORS = {
  header: {
    background: '#737373',
    font: '#ffffff'
  },
  body: {
    background: '#ffffff',
    font: '#444444'
  },
  footer: {
    background: '#143a50',
    font: '#ffffff'
  }
};

export const MAX_COLORS = 7;
export const SECTION_TYPES = ['header', 'body', 'footer'];

export const OPENGOV_LOGO_URL =
  // tslint:disable-next-line:max-line-length
  'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2097%2097%22%3E%3Ctitle%3Eog%3C%2Ftitle%3E%3Cpath%20d%3D%22M48.5%2C0A48.5%2C48.5%2C0%2C1%2C0%2C97%2C48.5%2C48.5%2C48.5%2C0%2C0%2C0%2C48.5%2C0h0Zm0%2C84.88A36.38%2C36.38%2C0%2C1%2C1%2C84.88%2C48.5%2C36.37%2C36.37%2C0%2C0%2C1%2C48.5%2C84.88ZM68%2C35.09H29a1.75%2C1.75%2C0%2C0%2C0-.91%2C3.24L46.74%2C49.78v20.9A1.76%2C1.76%2C0%2C0%2C0%2C48%2C72.37a2%2C2%2C0%2C0%2C0%2C.46.06A1.74%2C1.74%2C0%2C0%2C0%2C50%2C71.55L69.55%2C37.72A1.75%2C1.75%2C0%2C0%2C0%2C68%2C35.09Z%22%20style%3D%22fill%3A%23000%22%2F%3E%3C%2Fsvg%3E';
export const PROGRESS_TRACKER = 'progress-tracker';
